/* eslint-disable */
/**
 * The path of the `OrdersPage` to be consumed by a `<Router />`
 * @export
 */
export const ORDERS_PAGE_PATH = `/orders`;

/**
 * Create a `href` that will resolve to `OrdersPage`
 * @export
 * @returns {string} The `ORDERS_PAGE_PATH`
 */
export const createOrdersPageLink = () => ORDERS_PAGE_PATH;

/**
 * Determine if the current page is the `OrdersPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `OrdersPage`
 */
export const isOrdersPage = (match) => match.path === ORDERS_PAGE_PATH;
